import Dialog from "../../1. Core/Controls/Dialog/Dialog";
import {Team} from "../types";
import TextField from "../../1. Core/Controls/TextField/TextField";
import {ServerAPI} from "../../1. Core/ServerAPI";
import CheckBox from "../../1. Core/Controls/CheckBox/CheckBox";


export default class EditTeamDialog extends Dialog {

    private _Team: Team;
    private _name: TextField;
    private _logoUrl: TextField;
    private _isOpenCheckBox: CheckBox;
    private _chatUrl: TextField;

    constructor(props: any) {
        super(props);
    }

    _initFields(settings: object) {
        this._Team = {} as Team;
        super._initFields(settings);
        this._Mode = 'FullHeight';
        this._Caption = 'Edit Team';
        this._CloseOnFrameMouseDown = true;
        this._ShowHeader = true;
        this._ShowCloseButton = true;
        this._OkRK = 'Save';
        this._AutoDestroy = true;
    }

    _render() {
        super._render();

        this._name = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Name'
        });

        this._logoUrl = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Logo URL'
        });


        this._isOpenCheckBox = new CheckBox({
            ParentNode: this._contentNode,
            Content: 'Is Open',
            Checked: false
        })

        this._chatUrl = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Chat URL'
        });


        this.refresh();
    }

    async refresh() {
        this._name.setValue(this._Team.name);
        this._logoUrl.setValue(this._Team.logoUrl);
        this._isOpenCheckBox.setValue(this._Team.isOpen);
        this._chatUrl.setValue(this._Team.chatUrl);
    }

    async _onOkButtonClick() {
        this._Team.name = this._name.getValue();
        this._Team.logoUrl = this._logoUrl.getValue();
        this._Team.isOpen = this._isOpenCheckBox.getValue();
        this._Team.chatUrl = this._chatUrl.getValue();

        if (this._Team.id) {
            await ServerAPI.put(`/teams/${this._Team.id}`, this._Team);
        } else {
            await ServerAPI.post(`/teams`, this._Team);
        }

        this.EvOkButtonClick.fire(this);
        this.hide();
    }
}